// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font-befa {
  font-family: 'Montserrat' !important;
}

.befa-title {
  font-size: 24px;
  font-weight: 600;
  color: #404041;
  text-align: left;
}

.befa-memory-subtitle {
  font-size: 14px;
  font-weight: 600;
  color: #404041;
  text-align: left;
}
/* SORT ACTIVE */
.befa-btn-sort.active {
  background: #E8E9EB;
}

/* DELETE ALL */
.befa-btn-delete-all {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
}
.befa-btn-delete-all:hover {
  background: #E8E9EB;
}

/* TOOLTIP */
.befa-tooltip-wrapper {
  position: relative;
}
.befa-tooltip {
  position: absolute;
  bottom: 40px;
  right: 0;
  background: #fff;
  color: #333;
  font-size: 15px;
  padding: 13px;
  width: max-content;
  border-radius: 4px;
  opacity: 0;
  pointer-events: none;
  transition: .2s;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}
.befa-tooltip-wrapper:hover .befa-tooltip {
  opacity: 1;
}

/* ITEM DELETE */
.befa-btn-item-delete {
  background: transparent;
  border: none;
  cursor: pointer;
  color: #999;
}
.befa-btn-item-delete:hover {
  color: #e54848;
}

/* ADD INPUT */
.befa-input-add {
  width: 100%;
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #ddd;
}

/* TOOLBAR MAIN */
.befa-memory-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
}

/* LEFT SIDE */
.befa-btn-add {
  padding: 10px 10px;
  width: 50%;
  border-radius: 40px;
  border: 1px solid #404041;
  background: #fff;
  cursor: pointer;
  font-size: 14px;
}

.befa-toolbar-left {
  display: flex;
  align-items: center;
  gap: 5px;
  flex: 1 1;
}

/* SEARCH */
.befa-input-search.small {
  width: 50%;
  padding: 13px 19px;
  border-radius: 40px;
  border: 1px solid #404041;
}

/* RIGHT SIDE */
.befa-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/layout/MemoryModal.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;AACT;;AAEA,WAAW;AACX;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV","sourcesContent":[".font-befa {\r\n  font-family: 'Montserrat' !important;\r\n}\r\n\r\n.befa-title {\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  color: #404041;\r\n  text-align: left;\r\n}\r\n\r\n.befa-memory-subtitle {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #404041;\r\n  text-align: left;\r\n}\r\n/* SORT ACTIVE */\r\n.befa-btn-sort.active {\r\n  background: #E8E9EB;\r\n}\r\n\r\n/* DELETE ALL */\r\n.befa-btn-delete-all {\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 6px;\r\n  border-radius: 6px;\r\n}\r\n.befa-btn-delete-all:hover {\r\n  background: #E8E9EB;\r\n}\r\n\r\n/* TOOLTIP */\r\n.befa-tooltip-wrapper {\r\n  position: relative;\r\n}\r\n.befa-tooltip {\r\n  position: absolute;\r\n  bottom: 40px;\r\n  right: 0;\r\n  background: #fff;\r\n  color: #333;\r\n  font-size: 15px;\r\n  padding: 13px;\r\n  width: max-content;\r\n  border-radius: 4px;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transition: .2s;\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.15);\r\n}\r\n.befa-tooltip-wrapper:hover .befa-tooltip {\r\n  opacity: 1;\r\n}\r\n\r\n/* ITEM DELETE */\r\n.befa-btn-item-delete {\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #999;\r\n}\r\n.befa-btn-item-delete:hover {\r\n  color: #e54848;\r\n}\r\n\r\n/* ADD INPUT */\r\n.befa-input-add {\r\n  width: 100%;\r\n  margin-top: 8px;\r\n  padding: 8px 10px;\r\n  border-radius: 6px;\r\n  border: 1px solid #ddd;\r\n}\r\n\r\n/* TOOLBAR MAIN */\r\n.befa-memory-toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 5px;\r\n}\r\n\r\n/* LEFT SIDE */\r\n.befa-btn-add {\r\n  padding: 10px 10px;\r\n  width: 50%;\r\n  border-radius: 40px;\r\n  border: 1px solid #404041;\r\n  background: #fff;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n}\r\n\r\n.befa-toolbar-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  flex: 1;\r\n}\r\n\r\n/* SEARCH */\r\n.befa-input-search.small {\r\n  width: 50%;\r\n  padding: 13px 19px;\r\n  border-radius: 40px;\r\n  border: 1px solid #404041;\r\n}\r\n\r\n/* RIGHT SIDE */\r\n.befa-toolbar-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
